import { Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { VideoRecorderOffIcon } from 'assets/svg';
import { useAppSelector } from 'features/app/hooks';
import { callLanguageCodeSelector } from 'features/call/call-base/store/selectors';
import {
  useColdHandoffTakenClickHandlers,
  useColdHandoffTakenRnsHandlers,
} from 'features/cold-handoff/hooks';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { BaseHeader, Button, MainTemplate } from 'features/ui/elements';

export const ColdHandoffTaken: FC = () => {
  const { t } = useTranslation();
  const languageCode = useAppSelector(callLanguageCodeSelector);
  const { isHandoffSentReceived } = useColdHandoffTakenRnsHandlers();

  const { handleColdHandoffCancel } = useColdHandoffTakenClickHandlers();

  return (
    <MainTemplate header={<BaseHeader />}>
      <Container>
        <Icon />
        <Typography
          variant='h1'
          align='center'
          color={theme.palette.common.white}
          mt={15}
        >
          {t('pleaseWaitConfirm')}
        </Typography>
        <Typography variant='body1' color={theme.palette.grey[50]} mt={8}>
          {languageCode}
        </Typography>
        <SecondaryButton
          fullWidth
          size='small'
          color='secondary'
          title={t('cancelRequest')}
          disabled={isHandoffSentReceived}
          onClick={handleColdHandoffCancel}
        >
          {t('cancelRequest')}
        </SecondaryButton>
      </Container>
    </MainTemplate>
  );
};

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 432px;
  padding: ${theme.spacing(23)};
  border-radius: 8px;
  background: ${theme.palette.grey[900]};
`;

const Icon = styled(VideoRecorderOffIcon)`
  margin-top: ${theme.spacing(7)};
`;

const SecondaryButton = styled(Button)`
  margin-top: ${theme.spacing(16)};
`;
